module.exports = __webpack_public_path__ + "img/aaron-griffin-neon.0d1f82e.jpg";